import React from 'react';
import { useLocation } from 'react-router-dom';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';
import Container from 'common/Container';
import PropTypes from 'prop-types';

const TNO_DIGEST_SITE_URL =
  (typeof process !== 'undefined' && process.env && process.env.REACT_APP_TNO_SITE_URL) ||
  'https://tnonetwork.com';

/** Landings TNOCON: no mostramos el bloque TNO Digest en el pie (sin texto sustituto). */
function useIsTnoconLandingFooter() {
  const { pathname } = useLocation();
  const path = (pathname || '').toLowerCase();
  const host =
    typeof window !== 'undefined' ? String(window.location.hostname || '').toLowerCase() : '';

  const paths = new Set([
    '/pressstart',
    '/pressstart/presentacion',
    '/pressstart/presentacion/',
    '/business-level',
    '/business-level/presentacion',
    '/business-level/presentacion/',
    '/creators-guild',
    '/creators-guild/roadmap',
    '/creators-guild/roadmap/',
    '/creator',
    '/producer',
  ]);
  if (paths.has(path)) return true;

  const hosts = new Set([
    'tnocon.tnonetwork.com',
    'creators.tnonetwork.com',
    'producers.tnonetwork.com',
  ]);
  return hosts.has(host);
}

const Footer = ({ themeMode }) => {
  const hideDigest = useIsTnoconLandingFooter();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Box
          display={'flex'}
          justifyContent={'space-between'}
          alignItems={'center'}
          width={'100%'}
          flexDirection={{ xs: 'column', sm: 'row' }}
        >
          <Box
            display={'flex'}
            component="a"
            underline="none"
            href="/"
            title="TNO Network | Media Kit"
            height={55}
            width={45}
          >
            <Container
              height={{ xs: 28, md: 55 }}
              width={45}
              sx={{
                backgroundImage: themeMode === 'dark' ? 'url(/images/logos/iso_white.webp)' : 'url(/images/logos/iso_black.webp)',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                backgroundSize: 'contain',
                height: 55,
                width: 45,
                padding: "0 !important",
              }}
            />
          </Box>
        </Box>
      </Grid>
      <Grid item xs={12}>
        {!hideDigest && (
          <Typography
            align={'center'}
            variant={'body2'}
            color="textSecondary"
            component={'p'}
            sx={{ maxWidth: 720, mx: 'auto', mb: 1.5, lineHeight: 1.65 }}
          >
            <strong>TNO Digest</strong>
            {' — editorial y autoridad SEO en '}
            <Link
              href={TNO_DIGEST_SITE_URL}
              target="_blank"
              rel="noopener noreferrer"
              color="inherit"
              underline="hover"
            >
              tnonetwork.com
            </Link>
            {' — complementa la señal en vivo, el contenido On-Demand y la presencia digital de TNO Network.'}
          </Typography>
        )}
        <Typography
          align={'center'}
          variant={'subtitle2'}
          color="textSecondary"
          gutterBottom
        >
          &copy; TNO Network 2026 | The Content Evolution.
        </Typography>
      </Grid>
    </Grid>
  );
};

Footer.propTypes = {
  themeMode: PropTypes.string.isRequired,
};

export default Footer;
